import { Sentry } from "@/observability/sentry";
import "@/observability/posthog";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import "@/styles/global.css";
import "swiper/swiper-bundle.css";
import "flatpickr/dist/flatpickr.css";
import "driver.js/dist/driver.css";
import "@/styles/tour.css";
import App from "./App";
import { AppWrapper } from "@/components/common/PageMeta";
import { ThemeProvider } from "@/context/ThemeContext";
import { Toaster } from "@/components/ui/toast/Toaster";
import { initSentryUser } from "@/lib/auth";
import { queryClient } from "@/lib/queryClient";

// Restore user context if already logged in
initSentryUser();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Ocurrió un error inesperado.</p>}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <AppWrapper>
            <App />
          </AppWrapper>
          <Toaster />
        </ThemeProvider>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
